"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.identity = exports.engagementEvent = exports.trackerEvent = exports.routableEvent = void 0;
var merge_1 = __importDefault(require("lodash/merge"));
var uuid_1 = require("uuid");
var actor_1 = __importStar(require("./actor"));
var consents_1 = __importDefault(require("./consents"));
var device_1 = __importStar(require("./device"));
var experimentMetadata_1 = __importStar(require("./experimentMetadata"));
var experiments_1 = __importStar(require("./experiments"));
var location_1 = __importStar(require("./location"));
var objects_1 = __importStar(require("./objects"));
var origin_1 = __importStar(require("./origin"));
var provider_1 = __importStar(require("./provider"));
var session_1 = __importStar(require("./session"));
var tracker_1 = __importStar(require("./tracker"));
var utils_1 = require("./utils");
function routableEventDefaults(eventInput) {
    return (0, merge_1.default)({
        actor: (0, actor_1.defaultValue)(),
        provider: (0, provider_1.defaultValue)(),
    }, eventInput);
}
/**
 * Implements https://github.schibsted.io/spt-dataanalytics/event-formats/blob/master/schema/master/events/base-routable-event.json
 */
var routableEvent = function (eventInput) {
    return Object.assign({}, eventInput, {
        '@id': (0, uuid_1.v4)(),
        creationDate: (0, utils_1.dateTime)(),
        schema: (eventInput || {}).schema ||
            'http://schema.schibsted.com/events/base-routable-event.json/218.json#',
        provider: (0, provider_1.default)(eventInput),
        actor: (0, actor_1.default)(eventInput),
    });
};
exports.routableEvent = routableEvent;
exports.routableEvent.defaults = routableEventDefaults;
/**
 * Add default value to TrackerEventInput.
 * @todo type-bug
 */
function trackerEventInput(eventInput) {
    return (0, merge_1.default)({
        actor: (0, actor_1.defaultValue)(),
        experiments: (0, experiments_1.defaultValue)(),
        experimentMetadata: (0, experimentMetadata_1.defaultValue)(),
        device: (0, device_1.defaultValue)(),
        location: (0, location_1.defaultValue)(),
        object: (0, objects_1.defaultValue)(),
        origin: (0, origin_1.defaultValue)(),
        provider: (0, provider_1.defaultValue)(),
        session: (0, session_1.defaultValue)(),
        tracker: (0, tracker_1.defaultValue)(),
    }, eventInput);
}
/**
 * Implements https://github.schibsted.io/spt-dataanalytics/event-formats/blob/master/schema/master/events/tracker-event.json
 */
function trackerEvent(eventInput, sdkConfig) {
    var _a = eventInput || {}, _b = _a.type, type = _b === void 0 ? 'View' : _b, props = __rest(_a, ["type"]);
    var input = trackerEventInput(eventInput);
    var pageViewIdInput = (eventInput || {}).pageViewId;
    var pageViewIdSdk = (sdkConfig || {}).pageViewId;
    return Object.assign({}, props, {
        '@id': (0, uuid_1.v4)(),
        '@type': type,
        pageViewId: pageViewIdInput || pageViewIdSdk,
        creationDate: (0, utils_1.dateTime)(),
        schema: (eventInput || {}).schema ||
            'http://schema.schibsted.com/events/tracker-event.json/329.json',
        actor: (0, actor_1.default)(input),
        consents: (0, consents_1.default)(input),
        experiments: (0, experiments_1.default)(input),
        experimentMetadata: (0, experimentMetadata_1.default)(input),
        device: (0, device_1.default)(input),
        location: (0, location_1.default)(input),
        object: (0, objects_1.default)(input),
        origin: (0, origin_1.default)(input),
        provider: (0, provider_1.default)(input),
        session: (0, session_1.default)(input),
        target: input.target &&
            (0, objects_1.default)(Object.assign({}, input, { object: input.target })),
        tracker: (0, tracker_1.default)(input),
    });
}
exports.trackerEvent = trackerEvent;
trackerEvent.defaults = trackerEventInput;
function engagementEvent(eventInput, sdkConfig) {
    return Object.assign(trackerEvent(eventInput, sdkConfig), {
        schema: (eventInput || {}).schema ||
            'http://schema.schibsted.com/events/engagement-event.json/356.json',
        '@type': 'Engagement',
    });
}
exports.engagementEvent = engagementEvent;
engagementEvent.defaults = trackerEventInput;
function identity(eventInput) {
    return eventInput;
}
exports.identity = identity;
identity.defaults = function () { return ({}); };
